export function fmtNOK(n, { decimals = 0 } = {}) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "–";
  const v = Number(n);
  return v.toLocaleString("nb-NO", { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).replace(/\u00a0/g, " ");
}

export function fmtMoney(n, currency = "NOK") {
  if (n === null || n === undefined) return "–";
  return `${fmtNOK(n)} ${currency}`;
}

export function fmtCompact(n, currency = "NOK") {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "–";
  const v = Number(n);
  const abs = Math.abs(v);
  if (abs >= 1_000_000) {
    const m = v / 1_000_000;
    return `${m.toFixed(m >= 10 ? 1 : 1).replace(/\.0$/, "")} M${currency}`;
  }
  if (abs >= 1_000) return `${Math.round(v / 1000)}k`;
  return fmtNOK(v);
}

export function fmtPct(n, digits = 1) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "–";
  return `${Number(n).toFixed(digits).replace(/\.0$/, "")} %`;
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function parseDate(s) {
  if (!s) return null;
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function fmtDate(s, { year = false } = {}) {
  const d = parseDate(s);
  if (!d) return "–";
  const now = new Date();
  const showYear = year || d.getFullYear() !== now.getFullYear();
  return `${d.getDate()} ${MONTHS[d.getMonth()]}${showYear ? ` ${d.getFullYear()}` : ""}`;
}

export function fmtDateTime(s) {
  const d = parseDate(s);
  if (!d) return "–";
  return `${fmtDate(s)} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

export function relTime(s) {
  const d = parseDate(s);
  if (!d) return "";
  const diff = Date.now() - d.getTime();
  const days = Math.floor(diff / 86400000);
  if (days < 0) {
    const ahead = -days;
    if (ahead === 0) return "today";
    if (ahead === 1) return "tomorrow";
    return `in ${ahead} days`;
  }
  if (days === 0) {
    const h = Math.floor(diff / 3600000);
    if (h < 1) return "just now";
    return `${h}h ago`;
  }
  if (days === 1) return "yesterday";
  if (days < 30) return `${days} days ago`;
  const months = Math.floor(days / 30);
  return months === 1 ? "1 month ago" : `${months} months ago`;
}

export function daysUntil(s) {
  const d = parseDate(s);
  if (!d) return null;
  return Math.ceil((d.getTime() - Date.now()) / 86400000);
}

export function initials(name = "") {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("");
}

export function greeting() {
  const h = new Date().getHours();
  if (h < 5) return "Good night";
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
}

export function todayLong() {
  return new Date().toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" });
}

export function fileSize(bytes) {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
